//smooth scroll
$(document).ready(function(){
  // $('a[href^="#"]').on('click',function(e){
  //   e.preventDefault();
  //   var target = this.hash;
  //   var $target = $(target);
  //   $('html, body').stop().animate({
  //     'scrollTop': $target.offset().top
  //   }, 900, 'swing', function(){
  //     //window.location.hash = target;
  //   });
  // });

$('a.need-help-button').on('click', function(e){    
    e.preventDefault();
    // Replace the following with your unique custom trigger code copied from the editor
    promolayer.triggerDisplay('mgoDzFu74G2iwfo9j8pa');
});

  
  $('.product-medias__sticky a').on('click', function(e){
    var currentSlide = $('.product-single__media--selected').index();
    var target = $('.product-medias__main .swiper-slide').eq(currentSlide);
    $('html, body').stop().animate({
      'scrollTop': target.offset().top
    }, 750);
    $('.product-medias__main .swiper-slide video').each(function(){
      $(this)[0].plyr.play();
    });
  });
  $(window).scroll(function(){
    var windowHeight = $(window).height();
    var scrollTop = $(document).scrollTop();
    var scrollBottom = scrollTop + windowHeight;
    var currentSlide = -1;
    $('.product-medias__main .swiper-slide').each(function(index){
        if(scrollTop + windowHeight / 4 > $(this).offset().top && scrollBottom - windowHeight * 3 / 4 <= $(this).offset().top + $(this).height() && currentSlide !== index){
          currentSlide = index;
          $('.product-medias__sticky .responsive-image-wrapper:not(:eq('+currentSlide+'))').removeClass('current');
          $('.product-medias__sticky .responsive-image-wrapper:eq('+currentSlide+')').addClass('current');
        }
    });
  });
  $('.swatch-items-wrapper>.swatch-element.available').on('click', function(){
    setTimeout(function(){
      var selectedEle = $('.product-medias__media.product-single__media--selected');
      if(selectedEle.length == 1){
        $('html, body').stop().animate({
          'scrollTop': selectedEle.offset().top
        }, 750);
      }
    },100);
  });
});
